export const LASKUN_OLETUSYKSIKKO = 'kpl'

export interface LaskunYksikko {
  tunnus: string
  nimi: string
  unKoodi: string | null
  yleinen: boolean
}

export const LASKUN_YKSIKKOLUETTELO: LaskunYksikko[] = [
  { tunnus: LASKUN_OLETUSYKSIKKO, nimi: 'kappale', unKoodi: 'H87', yleinen: true },
  { tunnus: 'h', nimi: 'tunti', unKoodi: 'HUR', yleinen: true },
  { tunnus: 'pv', nimi: 'päivä', unKoodi: 'DAY', yleinen: true },
  { tunnus: 'kk', nimi: 'kuukausi', unKoodi: 'MON', yleinen: true },
  { tunnus: 'km', nimi: 'kilometri', unKoodi: 'KMT', yleinen: true },
  { tunnus: 'm', nimi: 'metri', unKoodi: 'MTR', yleinen: true },
  { tunnus: 'm²', nimi: 'neliömetri', unKoodi: 'MTK', yleinen: true },
  { tunnus: 'g', nimi: 'gramma', unKoodi: 'GRM', yleinen: true },
  { tunnus: 'kg', nimi: 'kilogramma', unKoodi: 'KGM', yleinen: true },
  { tunnus: 'ml', nimi: 'millilitra', unKoodi: 'MLT', yleinen: true },
  { tunnus: 'l', nimi: 'litra', unKoodi: 'LTR', yleinen: true },
  { tunnus: 'erä', nimi: 'erä', unKoodi: 'LO', yleinen: true },
  { tunnus: 'min', nimi: 'minuutti', unKoodi: 'MIN', yleinen: false },
  { tunnus: 's', nimi: 'sekunti', unKoodi: 'SEC', yleinen: false },
  { tunnus: 'vk', nimi: 'viikko', unKoodi: 'WEE', yleinen: false },
  { tunnus: 'v', nimi: 'vuosi', unKoodi: 'ANN', yleinen: false },
  { tunnus: 'vrk', nimi: 'vuorokausi', unKoodi: 'DAY', yleinen: false },
  { tunnus: 'm³', nimi: 'kuutiometri', unKoodi: 'MTQ', yleinen: false },
  { tunnus: 't', nimi: 'tonni', unKoodi: 'TNE', yleinen: false },
  { tunnus: 'mg', nimi: 'milligramma', unKoodi: 'MGM', yleinen: false },
  { tunnus: 'mm', nimi: 'millimetri', unKoodi: 'MMT', yleinen: false },
  { tunnus: 'cm', nimi: 'senttimetri', unKoodi: 'CMT', yleinen: false },
  { tunnus: 'dm', nimi: 'desimetri', unKoodi: 'DMT', yleinen: false },
  { tunnus: 'cm²', nimi: 'neliösenttimetri', unKoodi: 'CMK', yleinen: false },
  { tunnus: 'ha', nimi: 'hehtaari', unKoodi: 'H18', yleinen: false },
  { tunnus: 'dl', nimi: 'desilitra', unKoodi: 'DLT', yleinen: false },
  { tunnus: 'cl', nimi: 'senttilitra', unKoodi: 'CLT', yleinen: false },
  { tunnus: 'hl', nimi: 'hehtolitra', unKoodi: 'HLT', yleinen: false },
  { tunnus: 'pari', nimi: 'pari', unKoodi: 'PR', yleinen: false },
  { tunnus: 'pkt', nimi: 'pakkaus', unKoodi: 'XPK', yleinen: false },
  { tunnus: 'ltk', nimi: 'laatikko', unKoodi: 'XBX', yleinen: false },
  { tunnus: 'plo', nimi: 'pullo', unKoodi: 'XBO', yleinen: false },
  { tunnus: 'tlk', nimi: 'tölkki', unKoodi: 'XCA', yleinen: false },
  { tunnus: 'säkki', nimi: 'säkki', unKoodi: 'XBG', yleinen: false },
  { tunnus: 'rll', nimi: 'rulla', unKoodi: 'XRO', yleinen: false },
  { tunnus: 'arkki', nimi: 'arkki', unKoodi: 'XST', yleinen: false },
  { tunnus: 'lava', nimi: 'kuormalava', unKoodi: 'XPX', yleinen: false },
  { tunnus: 'setti', nimi: 'setti', unKoodi: 'SET', yleinen: false },
  { tunnus: 'kWh', nimi: 'kilowattitunti', unKoodi: 'KWH', yleinen: false },
  { tunnus: 'MWh', nimi: 'megawattitunti', unKoodi: 'MWH', yleinen: false },
  { tunnus: 'kW', nimi: 'kilowatti', unKoodi: 'KWT', yleinen: false },
  { tunnus: 'W', nimi: 'watti', unKoodi: 'WTT', yleinen: false },
  { tunnus: 'hlö', nimi: 'henkilö', unKoodi: 'IE', yleinen: false },
  { tunnus: 'kerta', nimi: 'kerta / suorite', unKoodi: 'E48', yleinen: false },
  { tunnus: 'annos', nimi: 'annos', unKoodi: 'NAR', yleinen: false },
  { tunnus: 'sivu', nimi: 'sivu', unKoodi: 'ZZ', yleinen: false },
  { tunnus: 'sana', nimi: 'sana', unKoodi: 'D68', yleinen: false },
  { tunnus: 'kpl/kk', nimi: 'kappaletta kuukaudessa', unKoodi: 'ZZ', yleinen: false },
  { tunnus: '%', nimi: 'prosentti', unKoodi: 'P1', yleinen: false },
]

export const LASKUN_YKSIKOT = LASKUN_YKSIKKOLUETTELO.filter(yksikko => yksikko.yleinen).map(yksikko => yksikko.tunnus)
